import { useContext } from 'react';
import { HelpContext, HelpContextType } from './HelpProvider';

export function useHelp(): HelpContextType {
  const context = useContext(HelpContext);
  if (!context) {
    throw new Error('useHelp must be used within a HelpProvider');
  }
  return context;
}
